import React from 'react';
import Wizard from 'components/Forms/Wizard/Wizard';
import { Container } from 'reactstrap';

function ApplicationWizard() {
	return <Container fluid className='mt-4'>
		<Wizard MODE="APPLICATION" />
	</Container>;
}

export default ApplicationWizard;


